import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

import { RestapiService } from './restapi.service';

@Injectable({
  providedIn: 'root'
})
export class RoutingService {

  public protectedRoutes = ['/perfil', '/historial'];
  public gameRoutes = [/* '/juego-inicio',  */'/juego-info', '/juego-trivia', '/juego-glosario', '/juego-recursos', '/login', '/trivia'];
  public publicRoutes: any;

  public previous: string;
  public full: string;
  public current: string;
  public level: string;
  public onRouteChange = new Subject();
  link: any;

  constructor(
    public http: HttpClient,
    public location: Location,
    public router: Router,
    public api: RestapiService
  ) {

    this.link = window.location.href;
   }


  goBack() {
    this.location.back();
    /* if (!this.previous || this.restricted(this.previous)) {
      this.goTo('/');
    }
    else {
      if (this.previous == this.current) {
        this.location.back();
      } else {
        this.goTo(this.previous);
      }
    } */
  }

  goTo(path: string, map?: string) {
    this.previous = this.current;
    this.setCurrent(path);
    this.router.navigateByUrl(path);
    this.onRouteChange.next(this.current);
    window.scrollTo(0, 0);
    /*  if (map) {
      this.map.mapDestroyNgo(map);
      setTimeout(() => {
        this.setCurrent(path);
        this.router.navigateByUrl(path);
        this.onRouteChange.next(this.current);
      }, 100);
    }
    else {
      this.setCurrent(path);
      this.router.navigateByUrl(path);
      this.onRouteChange.next(this.current);
    } */
  }

  setCurrent(path: string) {
    this.full = path;
    this.current = this.getCleanPath(path);
    this.level = this.getlevel(this.current);
    this.link = window.location.href;
    // console.log('CURRENT PATH', this.current)
    /*  console.log('setCurrent', this.current, this.user.isLogued())
     if (this.restricted(this.current)) {
       this.goTo('/login');
      this.presentToast('Inicie sesión para continuar', 'warning')
     } */
  }

  restricted(path: string) {
    /*  if (this.protectedRoutes.indexOf(path) >= 0 && !this.user.isLogued()) {
       return true;
     }
     else {
       return false;
     } */
  }

  game(path: string) {
    if (this.gameRoutes.indexOf(path) >= 0) {
      return true;
    }
    else {
      return false;
    }
  }

  getCleanPath(path: string) {
    return '/' + this.full.split('/')[1];
  }

  getlevel(path?: string) {
    if (this.protectedRoutes.indexOf(path) >= 0) {
      return 'protected';
    }
    else {
      return 'public';
    }
  }

  /* async presentToast(message: string, color?: string) {
    const toast = await this.toastController.create({
      message: message,
      duration: 2000,
      animated: true,
      color: (color) ? color : 'primary'
    });
    toast.present();
  } */

  copiShareLink(url?: any) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = url ? url : window.location.href;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    alert('Enlace copiado a portapapeles');
  }
}




